var exports = {
  "kL": "DiscoverySidebar.module__container___ZFgxQm",
  "CT": "DiscoverySidebar.module__navList___ZFgxQm",
  "pc": "DiscoverySidebar.module__navItem___ZFgxQm",
  "HW": "DiscoverySidebar.module__navItemActive___ZFgxQm",
  "T1": "DiscoverySidebar.module__navItemDisabled___ZFgxQm",
  "wz": "DiscoverySidebar.module__navItemIcon___ZFgxQm",
  "hk": "DiscoverySidebar.module__navItemLabel___ZFgxQm",
  "WG": "DiscoverySidebar.module__comingSoonBadge___ZFgxQm",
};

module.exports = exports;
